import Model from "flarum/Model";

export default class DecorationStore extends Model {}
Object.assign(DecorationStore.prototype, {
  id: Model.attribute("id"),
  purchase_id: Model.attribute("purchase_id"),
  item_title: Model.attribute("item_title"),
  item_desc: Model.attribute("item_desc"),
  item_type: Model.attribute("item_type"),
  item_cost: Model.attribute("item_cost"),
  item_sold: Model.attribute("item_sold"),
  item_label_recommend: Model.attribute("item_label_recommend"),
  item_label_popular: Model.attribute("item_label_popular"),
  item_amount: Model.attribute("item_amount"),
  item_discount: Model.attribute("item_discount"),
  item_discount_days: Model.attribute("item_discount_days"),
  item_discount_date: Model.attribute("item_discount_date"),
  item_property: Model.attribute("item_property"),
  purchase_type: Model.attribute("purchase_type"),
  assignedAt: Model.attribute("assigned_at"),
  isActivate: Model.attribute("isActivate"),
  sort: Model.attribute("sort"),
});
